// extracted by mini-css-extract-plugin
module.exports = {"containerInviteCode":"styles_containerInviteCode__OkTdY","inviteCode":"styles_inviteCode__uxV_K"};